/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * CancelUserSubscriptionResponseBase
 * auto generated base class for the model CancelUserSubscriptionResponseModel.
 */
export const CancelUserSubscriptionResponseModelBase = ModelBase.named('CancelUserSubscriptionResponse')
  .props({
    __typename: types.optional(types.literal('CancelUserSubscriptionResponse'), 'CancelUserSubscriptionResponse'),
    success: types.union(types.undefined, types.boolean)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CancelUserSubscriptionResponseModelSelector extends QueryBuilder {
  get success() {
    return this.__attr('success')
  }
}
export function selectFromCancelUserSubscriptionResponse() {
  return new CancelUserSubscriptionResponseModelSelector()
}

export const cancelUserSubscriptionResponseModelPrimitives = selectFromCancelUserSubscriptionResponse().success
